module.exports = __webpack_public_path__ + "static/img/qingqi.39eb1075.png";